import React from 'react';
import styled from 'styled-components';

interface IProps {
    flexDirection?: 'row' | 'row-reverse' | 'column' | 'column-reverse' | 'initial' | 'inherit';
    justifyContent?:
        | 'flex-start'
        | 'flex-end'
        | 'center'
        | 'space-between'
        | 'space-around'
        | 'space-evenly'
        | 'initial'
        | 'inherit';
    alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'initial' | 'inherit';
    flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse' | 'initial' | 'inherit';
    alignContent?:
        | 'stretch'
        | 'center'
        | 'flex-start'
        | 'flex-end'
        | 'space-between'
        | 'space-around'
        | 'initial'
        | 'inherit';
    order?: number | 'initial' | 'inherit';
    position?: number | 'relative' | 'absolute' | 'fixed' | 'static' | 'sticky' | 'inherit' | 'initial';
    alignSelf?: 'auto' | 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'baseline' | 'initial' | 'inherit';
    flexGrow?: number | 'initial' | 'inherit';
    flexShrink?: number | 'initial' | 'inherit';
    flexBasis?: number | 'auto' | 'initial' | 'inherit';
    classNames?: string;
    margin?: Array<string | number>;
    padding?: Array<string | number>;
    flex?: string | number;
    width?: string;
    backgroundColor?: string;
    background?: string;
    styles?: Record<string, unknown>;
    maxHeight?: string;
    minHeight?: string;
    height?: string;
    mobileMinHeight?: string;
    mobileWidth?: string;
    onClick?: (event: any) => void;
    flexDirectionMobile?: 'row' | 'row-reverse' | 'column' | 'column-reverse' | 'initial' | 'inherit';
    marginMobile?: string;
    id?: string;
}

const FlexWrapper = styled.section<IProps>`
    display: flex;
    box-sizing: border-box;
    flex-direction: ${(props) => props.flexDirection};
    justify-content: ${(props) => props.justifyContent};
    align-items: ${(props) => props.alignItems};
    align-content: ${(props) => props.alignContent};
    align-self: ${(props) => props.alignSelf};
    background-color: ${(props) => props.backgroundColor || 'transparent'};
    background: ${(props) => props.background || 'transparent'};
    flex-wrap: ${(props) => props.flexWrap};
    order: ${(props) => props.order};
    flex-grow: ${(props) => props.flexGrow};
    flex-shrink: ${(props) => props.flexShrink};
    flex-basis: ${(props) => props.flexBasis};
    flex: ${(props) => props.flex};
    margin: ${(props) =>
        props.margin ? props.margin.map((item) => (isNaN(Number(item)) ? item : item + 'px')).join(' ') : ''};
    padding: ${(props) =>
        props.padding ? props.padding.map((item) => (isNaN(Number(item)) ? item : item + 'px')).join(' ') : ''};
    width: ${(props) => (props.width ? props.width : null)};
    max-height: ${(props) => (props.maxHeight ? props.maxHeight : 'unset')};
    min-height: ${(props) => (props.minHeight ? props.minHeight : 'unset')};
    height: ${(props) => (props.height ? props.height : 'auto')};
    position: ${(props) => (props.position ? props.position : 'initial')};

    a {
        cursor: pointer !important;

        span,
        div {
            cursor: pointer !important;
        }
    }

    @media only screen and (max-width: 768px) {
        width: ${(props) => (props.mobileWidth ? props.mobileWidth : '100%')};
        height: auto;
        min-height: ${(props) => (props.mobileMinHeight ? props.mobileMinHeight : 'unset')};
        margin: ${(props) =>
            props.marginMobile
                ? props.marginMobile
                : props.flexDirectionMobile
                ? props.margin
                    ? props.margin.map((item) => (isNaN(Number(item)) ? item : item + 'px')).join(' ')
                    : ''
                : 0};
        padding: 0 5% 0 5%;
        flex-direction: ${(props) => props.flexDirectionMobile || props.flexDirection};
        border: none !important;

        button {
            width: ${(props) =>
                (props.flexDirectionMobile && props.flexDirectionMobile === 'column') ||
                (props.flexDirection && props.flexDirection === 'column')
                    ? '100%'
                    : 'auto'};
            margin: 10px 0;
        }
    }

    @media only screen and (max-width: 480px) {
        padding: 0 5% 0 5%;
        min-height: ${(props) => (props.mobileMinHeight ? props.mobileMinHeight : 'max-content')};
    }
`;

export class Flex extends React.Component<IProps> {
    public static defaultProps: IProps = {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        classNames: '',
        flex: 'none',
        margin: [],
        padding: [],
    };
    public render() {
        return (
            <FlexWrapper {...this.props} style={this.props.styles} className={[this.props.classNames].join(' ')}>
                {this.props.children}
            </FlexWrapper>
        );
    }
}

export default Flex;
